"use strict";

(function ($) {
  $.b2b = $.b2b || {};
  $.b2b.togglePasswordByButton = function ($btn) {
    var $input = $btn.siblings('input[type="password"], input[type="text"]').first();
    if ($input.length === 0) return;
    var isPassword = $input.attr('type') === 'password';
    $input.attr('type', isPassword ? 'text' : 'password');
    var $icon = $btn.find('i');
    if ($icon.length) {
      $icon.toggleClass('fa-eye fa-eye-slash');
    }
    $btn.attr('aria-label', isPassword ? 'Скрыть пароль' : 'Показать пароль');
    $btn.attr('title', isPassword ? 'Скрыть пароль' : 'Показать пароль');
  };
})(jQuery);